<template>
    <div class="eula-body mt-4 px-3">
      <div>
        <h5>Chariot MQTT Server by Cirrus Link Solutions Software License Agreement</h5>
        <p>
            <b> IMPORTANT - READ CAREFULLY: THIS CHARIOT MQTT SERVER BY CIRRUS LINK SOLUTIONS LLC® (THE "SOFTWARE") ") SOFTWARE LICENSE AGREEMENT ("CLSSLA") IS A LEGAL AGREEMENT BETWEEN YOU (EITHER AN INDIVIDUAL OR A SINGLE ENTITY) AND CIRRUS LINK SOLUTIONS LLC. BY INSTALLING, COPYING OR OTHERWISE USING THE SOFTWARE, YOU INDICATE YOUR ACCEPTANCE OF THE CLSSLA, INCLUDING THE LIMITED WARRANTY, DISCLAIMERS AND LIMITATION ON LIABILITY PROVISIONS.
            BY AGREEING TO THIS CLSSLA YOU ARE ALSO AGREEING TO RELEVANT THIRD PARTY SOFTWARE LICENSING AGREEMENTS FOR ANY OF THE MODULES YOU ARE UTILIZING.
            FURTHER,<u> YOU AGREE THAT THIS CLSSLA CONTROLS ALL ASPECTS OF THE RELATIONSHIP BETWEEN THE PARTIES WITH REGARD TOTHE LICENSING OF THE SOFTWARE AND SUPERCEDES ANY OTHER AGREEMENT BETWEEN YOU AND CIRRUS LINK SOLUTIONS, INCLUDING, BUT NOT LIMITED TO, LICENSEE PURCHASE ORDERS AND/OR TERMS AND CONDITIONS, AND WHETHER ENTERED INTO BEFORE OR AFTER YOUR ACCEPTANCE OF THIS AGREEMENT.</u>
            IF YOU DO NOT ACCEPT THE TERMS OF THIS AGREEMENT DON'T INSTALL, COPY OR OTHERWISE USE THE SOFTWARE.</b>
        </p>
        <p>
            <b>BY DOWNLOADING, INSTALLING AND/OR IMPLEMENTING THIS SOFTWARE YOU AGREE TO THE FOLLOWING LICENSE:</b>
        </p>
        <ol class="alpha-list-style">
            <li>
              <b>DEFINITIONS.</b>
              "You" and "Licensee" refers to the person, entity or organization which is using the Software and any successor or assignee of same. "Cirrus Link" refers to Cirrus Link Solutions, LLC and its successors or manufacturer and owner of this Software.
              You understand that this Sparkplug Aware MQTT Server is protected under a provisional patent filed with the United States Patent office.
            </li>
            <li>
              <b>AGREEMENT.</b>
              After reading the CLSSLA, if You do not agree to all of the terms of the CLSSLA, You may not use the Software.
              Unless You have a different license agreement signed by an authorized representative of Cirrus Link that coversthe licensing of the Software, your use of this Software indicates your acceptance of the terms of this CLSSLA, including,but not limited to, the warranty, disclaimers and limitations on liability provisions.
              All updates to the Software shall be considered part of the Software and subject to the terms of the CLSSLA. Revisions to this CLSSLA may accompany updates to the Software, in which case by installing such update, Customer accepts the terms of the CLSSLA as revised. The CLSSLA is not otherwise subject to addition, amendment, modification or exception unless in writing signed by You and an authorized representative of Cirrus Link.
              If you do not agree to the terms of this CLSSLA, do not install or use the Software
            </li>
            <li>
              <b>GRANT OF LICENSE.</b>
              The Software is an original work and protected by copyright and patent laws protecting the author's rights and intellectualproperty.
              Cirrus Link reserves all rights to any reproduction of the Software, including its documentation, logos, trademarks, icons and interface in whole or in part.
              This CLSSLA does not give You the right to any technical support for,or upgrades to, the Software which Cirrus Link may offer from time to time.
              Cirrus Link may, at its option and as part of its sales policy, make such technical support and upgrades available to registered users of the Software under terms to be determined from time to time by Cirrus Link.
            <ol>
                <li>
                  <b>Evaluation Copy.</b>
                  You may use the Software without charge on an evaluation basis. In the unregistered version your use is limited by providing atwo hour runtime only.
                  You must pay the license fee and activate your copy of the Software if you wish to use the Software without any limitation.
                </li>
                <li>
                  <b>Redistribution of Evaluation Copy.</b>
                  If You are using the Software on an evaluation basis, You may make copiesof the evaluation Software as you wish; give exact copies of the original evaluation Software to anyone; and distribute the evaluation Software in its unmodified form via electronic means (Internet, BBS's, Shareware distribution libraries, CD-ROMs, etc.).
                  You may not charge a fee for the copy or use of the evaluation Software itself, but You may charge a distribution fee that is reasonably related to any cost You incur distributing the evaluation Software (e.g. packaging).
                  You must not represent in any manner whatsoever that You are selling the Software itself. Your distribution of the evaluation Software will not entitle You to any compensation from CirrusLink.
                  You must distribute a copy of this CLSSLA with any copy of the Software.
                  Anyone to whom You distributethe Software is subject to this CLSSLA
                </li>
                <li>
                  <b>Registered Copy.</b>
                  After You have purchased the license for the Software and have received the serial number enabling the registered copy, You are licensed to copy the Software only into the memory of the number of computers corresponding to the number of licenses purchased.
                  Under no other circumstances may the Software be operated at the same time on more than the number of computers for which You have paid a separate license fee.
                  You may terminate this license at any time by destroying the original and all copies of the Software in whatever form you maintained it in.
                  You may permanently transfer all of your rights under this CLSSLA provided You transfer all copies of the Software (including copies of all prior versions if the Software is an upgrade) and retain none, and the recipient agrees to the terms of this CLSSLA
                </li>
                <li>
                  <b>Virtual Machines.</b>
                  If you plan to run the Software in multiple virtual computers or virtual servers, a license is required for each instance of the virtual computer or server where the Software will be installed.
                  If you plan to install the Software in the host operating system of the computer where the virtual machines are running, a license will also be required for the host operating system.
                </li>
                <li>
                  <b>RESTRICTIONS.</b>
                  You may not reverse engineer, de-compile or disassemble the Software, except and only to the extent that such activity is expressly permitted by applicable law notwithstanding this limitation.
                  You may not rent, lease or lend the Software.
                  You may not publish or publicly distribute any serial numbers, access codes, unlock-codes, passwords, or other end-user-specific registration information that would allow a third party to activate the Software without a valid license
                </li>
            </ol>
            </li>
            <li>
          <p>
            <b>THIRD PARTY LICENSES AND COPYRIGHT NOTICES</b>
          </p>

          <p>
            The Software may contain software from the following
            entities, whose inclusion is governed by the following third-party licenses and
            require the following copyright notices.
          </p>

          <ol>
            <li>
              <b>Eclipse Paho Client</b>
              <p>
                <b>Copyright © 2014 Eclipse Paho. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Eclipse Paho Client, which is licensed under the Eclipse Public License, Version 1.0. You can get the full source code for Eclipse Paho Client at:
                <a
                  href="https://repo.eclipse.org/content/repositories/paho-releases/"
                >https://repo.eclipse.org/content/repositories/paho-releases</a>
                A copy of the Eclipse Public License, Version 1.0 is available at
                <a
                  href="http://www.eclipse.org/legal/epl-v10.html"
                >http://www.eclipse.org/legal/epl-v10.html</a>
              </p>
            </li>
            <li>
              <b>Apache Shiro</b>
              <p>
                <b>Copyright © 2008-2020 The Apache Software Foundation</b>
              </p>

              <p>
                The Software contains Apache Shiro, which is licensed under the Apache License, Version 2.0. You can get the full source code for Apache Log4j at:
                <a
                  href="https://shiro.apache.org/"
                >https://shiro.apache.org/</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Apache HttpClient</b>
              <p>
                <b>Copyright © 2005-2020 The Apache Software Foundation. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Apache HttpClient, which is licensed under the Apache License, Version 2.0. You can get the full source code for Apache HttpClient at:
                <a
                  href="https://hc.apache.org/httpcomponents-client-ga/"
                >https://hc.apache.org/httpcomponents-client-ga</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>

            <li>
              <b>Apache HttpCore</b>
              <p>
                <b>Copyright © 2005-2020 The Apache Software Foundation. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Apache HttpCore, which is licensed under the Apache License, Version 2.0. You can get the full source code for Apache HttpCore at:
                <a
                  href="https://hc.apache.org/httpcomponents-client-ga/"
                >https://hc.apache.org/httpcomponents-client-ga</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Jackson Annotations</b>
              <p>
                <b>Copyright: 2013, FasterXML, LLC, Seattle, USA</b>
              </p>

              <p>
                The Software contains Jackson Annotations, which is licensed under the Apache License, Version 2.0. You can get the full source code for Jackson Annotations at:
                <a
                  href="https://github.com/FasterXML/jackson-annotations"
                >https://github.com/FasterXML/jackson-annotations</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>

            <li>
              <b>Jackson Core</b>
              <p>
                <b>Copyright: 2013, FasterXML, LLC, Seattle, USA</b>
              </p>

              <p>
                The Software contains Jackson Core, which is licensed under the Apache License, Version 2.0. You can get the full source code for Jackson Core at:
                <a
                  href="https://github.com/FasterXML/jackson-core"
                >https://github.com/FasterXML/jackson-core</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>

            <li>
              <b>Jackson Databind</b>
              <p>
                <b>Copyright: 2013, FasterXML, LLC, Seattle, USA</b>
              </p>

              <p>
                The Software contains Jackson Databind, which is licensed under the Apache License, Version 2.0. You can get the full source code for Jackson Databind at:
                <a
                  href="https://github.com/FasterXML/jackson-databind/"
                >https://github.com/FasterXML/jackson-databind</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>

            <li>
              <b>Jackson Dataformat Properties</b>
              <p>
                <b>Copyright: 2013, FasterXML, LLC, Seattle, USA</b>
              </p>

              <p>
                The Software contains Jackson Dataformat Properties, which is licensed under the Apache License, Version 2.0. You can get the full source code for Jackson Databind at:
                <a
                  href="https://github.com/FasterXML/jackson-dataformat-properties/"
                >https://github.com/FasterXML/jackson-dataformat-properties</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>

            <li>
              <b>Logback Classic & Core Modules</b>
              <p>
                <b>Copyright © 2019 QOS.ch</b>
              </p>

              <p>
                The Software contains the Logback Classic and Core Modules, which is licensed under the Eclipse Public License, Version 1.0. You can get the full source code for the Logback Classic & Core Modules at:
                <a
                  href="https://logback.qos.ch/download.html"
                >https://logback.qos.ch/download.html</a>
                A copy of the Eclipse Public License, Version 1.0 is available at
                <a
                  href="http://www.eclipse.org/legal/epl-v10.html"
                >http://www.eclipse.org/legal/epl-v10.html</a>
              </p>
            </li>
            <li>
              <b>SLF4J</b>
              <p>
                <b>Copyright © 2004-2019 QOS.ch</b>
              </p>

              <p>
                The Software contains SLF4J, which is licensed under the MIT License. You can get the full source code for SLF4J at:
                <a
                  href="http://www.slf4j.org/download.html"
                >http://www.slf4j.org/download.html</a>
                A copy of the MIT License is available at
                <a
                  href="http://www.slf4j.org/license.html"
                >http://www.slf4j.org/license.html</a>
              </p>
            </li>

            <li>
              <b>Apache Log4j</b>
              <p>
                <b>Copyright &copy; 1999-2012 Apache Software Foundation.</b>
              </p>

              <p>
                The Software contains Apache Log4j, which is licensed under the Apache License, Version 2.0. You can get the full source code for Apache Log4j at:
                <a
                  href="http://logging.apache.org/log4j/1.2/"
                >http://logging.apache.org/log4j/1.2</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Apache Commons Codec</b>
              <p>
                <b>Copyright © 2002-2014 The Apache Software Foundation. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Apache Commons Codec, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="http://commons.apache.org/proper/commons-codec/"
                >http://commons.apache.org/proper/commons-codec</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Apache Commons Logging</b>
              <p>
                <b>Copyright © 2001-2014 The Apache Software Foundation. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Apache Commons Logging, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="http://commons.apache.org/proper/commons-logging/"
                >http://commons.apache.org/proper/commons-logging</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Apache Commons FileUpload</b>
              <p>
                <b>Copyright © 2002-2019 The Apache Software Foundation. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Apache Commons FileUpload, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="http://commons.apache.org/proper/commons-fileupload/"
                >http://commons.apache.org/proper/commons-fileupload</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Apache Commons IO</b>
              <p>
                <b>Copyright © 2002-2020 The Apache Software Foundation. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Apache Commons IO, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="http://commons.apache.org/proper/commons-io/"
                >http://commons.apache.org/proper/commons-io</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Apache Commons Lang</b>
              <p>
                <b>Copyright © 2001-2020 The Apache Software Foundation. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Apache Commons Lang, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="http://commons.apache.org/proper/commons-lang/"
                >http://commons.apache.org/proper/commons-lang</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Apache Commons BeanUtils</b>
              <p>
                <b>Copyright © 2000-2019 The Apache Software Foundation. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Apache Commons BeanUtils, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="http://commons.apache.org/proper/commons-beanutils/"
                >http://commons.apache.org/proper/commons-beanutils</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Apache Commons Collections</b>
              <p>
                <b>Copyright © 2001-2020 The Apache Software Foundation. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Apache Commons Collections, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="http://commons.apache.org/proper/commons-collections/"
                >http://commons.apache.org/proper/commons-collections</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Apache Commons Compress</b>
              <p>
                <b>Copyright © 2020 The Apache Software Foundation. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Apache Commons Compress, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="http://commons.apache.org/proper/commons-compress/"
                >http://commons.apache.org/proper/commons-compress</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Apache Felix</b>
              <p>
                <b>Copyright © 2020 The Apache Software Foundation. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Apache Felix, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="https://felix.apache.org/"
                >https://felix.apache.org</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Apache Tomcat</b>
              <p>
                <b>Copyright © 1999-2020 The Apache Software Foundation. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Apache Tomcat, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="https://tomcat.apache.org/"
                >https://tomcat.apache.org</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Bouncy Castle Provider</b>
              <p>
                <b>Copyright © 2000-2020 The Apache Software Foundation. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Bouncy Castle Provider, which is licensed under the Bouncy Castle License. You can find more information at:
                <a
                  href="https://www.bouncycastle.org/"
                >https://www.bouncycastle.org</a>
                A copy of the Bouncy Castle License is available at
                <a
                  href="https://www.bouncycastle.org/licence.html"
                >https://www.bouncycastle.org/licence.html</a>
              </p>
            </li>
            <li>
              <b>JSON Web Tokens</b>
              <p>
                <b>Copyright (c) 2013-2014 Auth0 Inc.</b>
              </p>

              <p>
                The Software contains JSON Web Tokens, which is licensed under the MIT License. You can find more information at:
                <a
                  href="https://jwt.io//"
                >https://jwt.io/</a>
                A copy of the license is available at
                <a
                  href="https://github.com/jsonwebtoken/jsonwebtoken.github.io/blob/master/LICENSE.txt"
                >https://github.com/jsonwebtoken/jsonwebtoken.github.io/blob/master/LICENSE.txt</a>
              </p>
            </li>
            <li>
              <b>Eclipse Tahu</b>
              <p>
                <b>Copyright © 2014-2019 Cirrus Link Solutions and others</b>
              </p>

              <p>
                The Software contains Eclipse Tahu, which is licensed under the Eclipse Public License, Version 2.0. You can get the full source code for Eclipse Tahu at:
                <a
                  href="https://github.com/eclipse/tahu"
                >https://github.com/eclipse/tahu</a>
                A copy of the Eclipse Public License, Version 2.0 is available at
                <a
                  href="http://www.eclipse.org/legal/epl-v20.html"
                >http://www.eclipse.org/legal/epl-v20.html</a>
              </p>
            </li>
            <li>
              <b>Eclipse Jetty</b>
              <p>
                <b>Copyright © The Eclipse Foundation</b>
              </p>

              <p>
                The Software contains Eclipse Jetty 9, which is dual licensed under the Apache License 2.0 and Eclipse Public License 1.0. You can find more information at:
                <a
                  href="https://www.eclipse.org/jetty/licenses.php"
                >https://www.eclipse.org/jetty/licenses.php</a>
                A copy of the Eclipse Public License, Version 1.0 is available at .
                <a
                  href="https://www.eclipse.org/legal/epl-v10.html"
                >https://www.eclipse.org/legal/epl-v10.html</a>
                A copy of the Apache License, Version 2.0 is available at http://www.apache.org/licenses/LICENSE-2.0
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>
            <li>
              <b>Google Protocol Buffers</b>
              <p>
                <b>Copyright © 2014, Google Inc. All rights reserved.</b>
              </p>

              <p>
                The Software contains Google Protocol Buffers, which is licensed under a BSD style license. You can get the full source code for Google Protocol Buffers at:
                <a
                  href="https://github.com/google/protobuf"
                >https://github.com/google/protobuf</a>
                A copy of the license is available at
                <a
                  href="https://github.com/google/protobuf/blob/master/LICENSE"
                >https://github.com/google/protobuf/blob/master/LICENSE</a>
              </p>
            </li>

            <li>
              <b>Google Conscrypt</b>

              <p>
                <b>Copyright: © 2016 The Android Open Source Project</b>
              </p>

              <p>
                The Software contains Google Conscrypt, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="https://conscrypt.org/"
                >https://conscrypt.org/</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>

            <li>
              <b>OSGi Companion Code</b>
              <p>
                <b>Copyright © 2011-2018 LICENSE4J.</b>
              </p>

              <p>
                The Software contains the OSGi Companion Code code, which is licensed under the OSGi Specification License, Version 2.0. You can find more information at:
                <a
                  href="https://www.osgi.org/release-6-1/"
                >https://www.osgi.org/release-6-1/</a>
              </p>
            </li>

            <li>
              <b>TestNG</b>
              <p>
                <b>Copyright © 2004-2019 Cédric Beust, the TestNG team</b>
              </p>

              <p>
                The Software contains the TestNG, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="https://testng.org/"
                >https://testng.org/</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>

            <li>
              <b>junixsocket</b>
              <p>
                <b>Copyright © 2009-2022 Christian Kohlschütter</b>
              </p>

              <p>
                The Software contains junixsocket, which is licensed under the Apache License 2.0
                <a
                  href="https://github.com/kohlschutter/junixsocket/blob/main/NOTICE"
                >https://github.com/kohlschutter/junixsocket/blob/main/NOTICE</a>
              </p>
            </li>

            <li>
              <b>License4J Runtime Library</b>
              <p>
                <b>Copyright © 2011-2018 LICENSE4J</b>
              </p>

              <p>
                This Software contains License4J Runtime Library
                <a
                  href="https://www.license4j.com"
                >https://www.license4j.com</a>
              </p>
            </li>

            <li>
              <b>Java-WebSocket</b>
              <p>
                <b>Copyright © 2010-2020 Nathan Rajlich</b>
              </p>

              <p>
                The Software contains Java-WebSocket, which is licensed under MIT License
                <a
                  href="https://github.com/TooTallNate/Java-WebSocket/blob/master/LICENSE"
                >https://github.com/TooTallNate/Java-WebSocket/blob/master/LICENSE</a>
              </p>
            </li>

            <li>
              <b>OSGi Core</b>
              <p>
                <b>Copyright © 2000-2015 OSGi Alliance</b>
              </p>

              <p>
                The Software contains OSGi Core, which is licensed under the OSGi Specification License, Version 2.0
                <a
                  href="https://docs.osgi.org/javadoc/r6/core/LICENSE.html"
                >https://docs.osgi.org/javadoc/r6/core/LICENSE.html</a>
              </p>
            </li>

            <li>
              <b>gethostname4j</b>
              <p>
                <b>Copyright © 2017 Matt Sheppard</b>
              </p>

              <p>
                The Software contains gethostname4j, which is licensed under MIT License
                <a
                  href="https://github.com/mattsheppard/gethostname4j/blob/master/LICENSE"
                >https://github.com/mattsheppard/gethostname4j/blob/master/LICENSE</a>
              </p>
            </li>

            <li>
              <b>JCommander</b>
              <p>
                <b>Copyright © 2004-2019 Cédric Beust</b>
              </p>

              <p>
                The Software contains the JCommander, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="https://jcommander.org/"
                >https://jcommander.org</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>

            <li>
              <b>SnakeYAML</b>
              <p>
                <b>Copyright (c) 2008, http://www.snakeyaml.org</b>
              </p>

              <p>
                The Software contains the SnakeYAML, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="http://www.snakeyaml.org/"
                >http://www.snakeyaml.org</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>

            <li>
              <b>AssertJ Core</b>
              <p>
                <b>Copyright 2012-2016, the original author or authors</b>
              </p>

              <p>
                The Software contains the AssertJ Core, which is licensed under the Apache License, Version 2.0. You can find more information at:
                <a
                  href="https://assertj.github.io/doc/"
                >https://assertj.github.io/doc</a>
                A copy of the Apache License, Version 2.0 is available at
                <a
                  href="http://www.apache.org/licenses/LICENSE-2.0"
                >http://www.apache.org/licenses/LICENSE-2.0</a>
              </p>
            </li>

            <li>
              <b>JUnit</b>
              <p>
                <b>Copyright © 2002-2014 JUnit. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains the JUnit, which is licensed under the Eclipse Public License, Version 1.0. You can find more information at:
                <a
                  href="https://junit.org/junit4/"
                >https://junit.org/junit4</a>
                A copy of the Eclipse Public License, Version 1.0 is available at
                <a
                  href="https://www.eclipse.org/legal/epl-v10.html"
                >https://www.eclipse.org/legal/epl-v10.html</a>
              </p>
            </li>

            <li>
              <b>Java Hamcrest</b>
              <p>
                <b>Copyright © 2012-2019 hamcrest.org</b>
              </p>

              <p>
                The Software contains the Java Hamcrest, which is licensed under the BSD License. You can find more information at:
                <a
                  href="http://hamcrest.org/JavaHamcrest/"
                >http://hamcrest.org/JavaHamcrest</a>.
                A copy of the BSD License is available at
                <a
                  href="https://opensource.org/licenses/BSD-3-Clause"
                >https://opensource.org/licenses/BSD-3-Clause</a>
              </p>
            </li>
            <li>
              <b>H2 Database</b>
              <p>
                <b>Copyright © 2017 QOS.ch</b>
              </p>

              <p>
                The Software contains the H2 Database, which is licensed under either the Eclipse Public License, Version 1.0 or the Mozilla Public License, Version 2.0. You can get the full source code for the H2 Database at:
                <a
                  href="https://github.com/h2database/h2database"
                >https://github.com/h2database/h2database</a>.
                A copy of the Eclipse Public License, Version 1.0 is available at
                <a
                  href="http://www.eclipse.org/legal/epl-v10.html"
                >http://www.eclipse.org/legal/epl-v10.html</a>
                A copy of the Mozilla Public License, Version 2.0 is available at
                <a
                  href="https://www.mozilla.org/en-US/MPL/2.0/"
                >https://www.mozilla.org/en-US/MPL/2.0/</a>
              </p>
            </li>
            <li>
              <b>Axios</b>
              <p>
                <b>Copyright (c) 2014-2020 Matt Zabriskie</b>
              </p>

              <p>
                The Software contains Axios, which is licensed under the MIT license. You can get the full source code for Axios:
                <a
                  href="https://github.com/axios/axios"
                >https://github.com/axios/axios</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/axios/axios/blob/master/LICENSE"
                >https://github.com/axios/axios/blob/master/LICENSE</a>
              </p>
            </li>
            <li>
              <b>Bootstrap</b>

              <p>
                The Software contains Bootstrap, which is licensed under the MIT license. You can get the full source code for Bootstrap:
                <a
                  href="https://github.com/twbs/bootstrap"
                >https://github.com/twbs/bootstrap</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/twbs/bootstrap/blob/main/LICENSE"
                >https://github.com/twbs/bootstrap/blob/main/LICENSE</a>
              </p>
            </li>
            <li>
              <b>BootstrapVue</b>

              <p>
                The Software contains BootstrapVue, which is licensed under the MIT license. You can get the full source code for BootstrapVue:
                <a
                  href="https://github.com/bootstrap-vue/bootstrap-vue"
                >https://github.com/bootstrap-vue/bootstrap-vue</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/bootstrap-vue/bootstrap-vue/blob/dev/LICENSE"
                >https://github.com/bootstrap-vue/bootstrap-vue/blob/dev/LICENSE</a>
              </p>
            </li>
            <li>
              <b>core-js</b>
              <p>
                <b>Copyright (c) 2014-2020 Denis Pushkarev</b>
              </p>

              <p>
                The Software contains core-js, which is licensed under the MIT license. You can get the full source code for core-js:
                <a
                  href="https://github.com/zloirock/core-js"
                >https://github.com/zloirock/core-js</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/zloirock/core-js/blob/master/LICENSE"
                >https://github.com/zloirock/core-js/blob/master/LICENSE</a>
              </p>
            </li>
            <li>
              <b>Day.js</b>
              <p>
                <b>Copyright (c) 2018-2020, iamkun</b>
              </p>

              <p>
                The Software contains Day.js, which is licensed under the MIT license. You can get the full source code for Day.js:
                <a
                  href="https://github.com/iamkun/dayjs"
                >https://github.com/iamkun/dayjs</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/iamkun/dayjs/blob/dev/LICENSE"
                >https://github.com/iamkun/dayjs/blob/dev/LICENSE</a>
              </p>
            </li>
            <li>
              <b>Interaction Observer</b>
              <p>
                <b>Copyright 2016 Google Inc. All Rights Reserved.</b>
              </p>

              <p>
                The Software contains Interaction Observer, which is licensed under the W3C license. You can get the full source code for Interaction Observer:
                <a
                  href="https://github.com/w3c/IntersectionObserver"
                >https://github.com/w3c/IntersectionObserver</a>.
                A copy of the license is available at
                <a
                  href="https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document"
                >https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document</a>
              </p>
            </li>
            <li>
              <b>serve</b>
              <p>
                <b>Copyright (c) 2018 ZEIT, Inc.</b>
              </p>

              <p>
                The Software contains serve, which is licensed under the MIT license. You can get the full source code for serve:
                <a
                  href="https://github.com/vercel/serve"
                >https://github.com/vercel/serve</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/vercel/serve/blob/master/LICENSE"
                >https://github.com/vercel/serve/blob/master/LICENSE</a>
              </p>
            </li>
            <li>
              <b>vue</b>
              <p>
                <b>Copyright (c) 2013-2020, Yuxi (Evan) You</b>
              </p>

              <p>
                The Software contains vue, which is licensed under the MIT license. You can get the full source code for vue:
                <a
                  href="https://github.com/vuejs/vue"
                >https://github.com/vuejs/vue</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/vuejs/vue/blob/dev/LICENSE"
                >https://github.com/vuejs/vue/blob/dev/LICENSE</a>
              </p>
            </li>
            <li>
              <b>vue-awesome-countdown</b>
              <p>
                <b>Copyright (c) 2018 LinQuan</b>
              </p>

              <p>
                The Software contains vue-awesome-countdown, which is licensed under the MIT license. You can get the full source code for vue-awesome-countdown:
                <a
                  href="https://github.com/mlinquan/vue-awesome-countdown"
                >https://github.com/mlinquan/vue-awesome-countdown</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/mlinquan/vue-awesome-countdown/blob/master/LICENSE"
                >https://github.com/mlinquan/vue-awesome-countdown/blob/master/LICENSE</a>
              </p>
            </li>
            <li>
              <b>vue-clipboard2</b>
              <p>
                <b>Copyright (c) 2017 Inndy</b>
              </p>

              <p>
                The Software contains vue-clipboard2, which is licensed under the MIT license. You can get the full source code for vue-clipboard2:
                <a
                  href="https://github.com/Inndy/vue-clipboard2"
                >https://github.com/Inndy/vue-clipboard2</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/Inndy/vue-clipboard2/blob/master/LICENSE"
                >https://github.com/Inndy/vue-clipboard2/blob/master/LICENSE</a>
              </p>
            </li>
            <li>
              <b>vue-i18n</b>
              <p>
                <b>Copyright © 2020 kazuya kawaguchi</b>
              </p>

              <p>
                The Software contains vue-i18n, which is licensed under the MIT license. You can get the full source code for vue-i18n:
                <a
                  href="https://github.com/kazupon/vue-i18n"
                >https://github.com/kazupon/vue-i18n</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/kazupon/vue-i18n/blob/v8.x/LICENSE"
                >https://github.com/kazupon/vue-i18n/blob/v8.x/LICENSE</a>
              </p>
            </li>
            <li>
              <b>vue-multiselect</b>
              <p>
                <b>Copyright (c) 2016 Damian Dulisz</b>
              </p>

              <p>
                The Software contains vue-multiselect, which is licensed under the MIT license. You can get the full source code for vue-multiselect:
                <a
                  href="https://github.com/shentao/vue-multiselect"
                >https://github.com/shentao/vue-multiselect</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/shentao/vue-multiselect/blob/master/LICENSE"
                >https://github.com/shentao/vue-multiselect/blob/master/LICENSE</a>
              </p>
            </li>
            <li>
              <b>vue-router</b>
              <p>
                <b>Copyright (c) 2013-2020 Evan You</b>
              </p>

              <p>
                The Software contains vue-router, which is licensed under the MIT license. You can get the full source code for vue-router:
                <a
                  href="https://github.com/vuejs/vue-router"
                >https://github.com/vuejs/vue-router</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/vuejs/vue-router/blob/dev/LICENSE"
                >https://github.com/vuejs/vue-router/blob/dev/LICENSE</a>
              </p>
            </li>
            <li>
              <b>vuelidate</b>
              <p>
                <b>Copyright (c) 2019 Damian Dulisz</b>
              </p>

              <p>
                The Software contains vuelidate, which is licensed under the MIT license. You can get the full source code for vuelidate:
                <a
                  href="https://github.com/vuelidate/vuelidate"
                >https://github.com/vuelidate/vuelidate</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/vuelidate/vuelidate/blob/master/LICENSE"
                >https://github.com/vuelidate/vuelidate/blob/master/LICENSE</a>
              </p>
            </li>
            <li>
              <b>vuex</b>
              <p>
                <b>Copyright (c) 2015-2020 Evan You</b>
              </p>

              <p>
                The Software contains vuex, which is licensed under the MIT license. You can get the full source code for vuex:
                <a
                  href="https://github.com/vuejs/vuex"
                >https://github.com/vuejs/vuex</a>.
                A copy of the license is available at
                <a
                  href="https://github.com/vuejs/vuex/blob/dev/LICENSE"
                >https://github.com/vuejs/vuex/blob/dev/LICENSE</a>
              </p>
            </li>
          </ol>
        </li>
            <li>
              <b>OWNERSHIP OF SOFTWARE.</b>
              The Software is protected by the laws of the United States and other countries, and through international treaty provisions.
              You may not remove any copyright notices from the Software.
              Cirrus Link may make changes to the Software at any time without notice, but is not obligated to support or update the Software
              Except asotherwise expressly provided in this CLSSLA, Cirrus Link grants no express or implied right under Cirrus Link patents, copyrights, trademarks or other intellectual property rights.
            </li>
            <li>
              <b>PROHIBITIONS.</b>
              Ownership of all copies of the Software remains with Cirrus Link.
              You are not obtaining ownership ofthe Software or any intellectual property rights related to it by licensing the Software.
              You may not sublicense, rent, lease,convey, translate, decompile or disassemble the Software for any purpose. Permission must be obtained before mirroring or redistributing the evaluation copies of the Software.
              You may not convert this Software or its parts to a different computer language or environment, either manually, or using an automated conversion tool, such that this Software or anymodification thereof will run under any language, software, or program other than implemented by Cirrus Link.
              You agree that any modifications made to this Software belong to Cirrus Link and are permitted for your exclusive use during the period of this CLSSLA, and may not be transferred, sold or licensed to another entity.
            </li>
            <li>
              <b>WARRANTY.</b>
              Cirrus Link warrants that it is the owner of the Software or has the right to grant the license (including the third party software licenses as more specifically provided under section 2 below) described in this CLSSLA without violating the rights of any third party.
            </li>
            <li>
              <b>DISCLAIMER.</b>
              THE SOFTWARE IS PROVIDED ON AN "AS IS" BASIS, WITHOUT WARRANTIES OF ANY KIND, INCLUDING, WITHOUT LIMITATION, THE WARRANTIES OF: (a) MERCHANTABILITY; (b) FITNESS FOR A PARTICULAR PURPOSE; AND (c) NONINFRINGEMENT.
              YOU ASSUME THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF THE SOFTWARE.
              SHOULD THE SOFTWARE PROVE DEFECTIVE, YOU ASSUME THE ENTIRE RISK OR COST ASSOCIATED WITH SUCH DEFECT AND ANY SERVICE AND REPAIR.
            </li>
            <li>
              <b>LIMITATION OF LIABILITY.</b>
              NEITHER CIRRUS LINK NOR ANYONE INVOLVED IN THE PRODUCTION OR DELIVERY OF THIS SOFTWARE SHALL BE LIABLE FOR ANY INDIRECT, CONSEQUENTIAL OR INCIDENTAL DAMAGES ARISING OUT OF THE USE OR INABILITY TO USE SUCH SOFTWARE EVEN IF CIRRUS LINK HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR CLAIMS.
              IN NO EVENT SHALL CIRRUS LINK LIABILITY FOR ANY DAMAGES EXCEED THE PRICE PAID FOR THE LICENSE TO USETHE SOFTWARE, REGARDLESS OF THE FORM OF CLAIM. THE PERSON USING THE SOFTWARE BEARS ALL RISK AS TO THE QUALITY AND PERFORMANCE OF THE SOFTWARE.
            </li>
            <li>
              <b>EXPORT RESTRICTIONS.</b>
              All Software and technical data delivered under this Agreement are subject to US export control laws and may be subject to export or import regulations in other countries.
              You agree to comply strictly with all such laws and regulations and acknowledge that you have the responsibility to obtain such licenses to export, re-export, orimport as may be required after delivery to you. These laws include restrictions on destinations, end users and end use.
            </li>
            <li>
              <b>TERMINATION.</b>
              This CLSSLA is effective until terminated.
              This CLSSLA terminates on the date of the first occurrence of either of the following events: (1) The expiration of one month from written notice of termination from Youto Cirrus Link; or (2) At any time if You violate the terms of this CLSSLA.
              Upon termination You shall destroy all copies of the Software, including modified copies, if any. You agree that monetary damages alone is not an adequate and just relief resulting from any breach of this CLSSLA, that a court order prohibiting any further breach of this CLSSLA is necessary to prevent further damages, and that you will not oppose any reasonable request for a temporary restraining order, preliminary injunction, or other relief sought by Cirrus Link in the event of a breach of this CLSSLA.
              Cirrus Link shall not be required to notify You of any breach, nor make any demand or claim against You resulting from any such breach, or for a demand to stop any use or distribution in violation of the terms of this CLSSLA, and You agree that any breach of this CLSSLA and damages resulting therefrom shall relate back to the first and earliest breach thereof.
              Failure of Cirrus Link to enforce its rights pursuant to this CLSSLA shall not constitute a waiver of such rights, and shall not prejudice Cirrus Link in any later enforcement of its rights or rights to seek damages therefrom.
            </li>
            <li>
              <b>UPGRADES.</b>
              If You acquired this Software as an upgrade of a previous version, this CLSSLA replaces and supersedes any prior CLSSLA.
              You may continue to use the previous version of the Software, provided that both the previous versionand the upgrade are installed on the same computer at all times.
              You may not have a previous version and the related upgrade version installed on separate computers at any time.
              Once you have installed the upgrades and are satisfied that the upgrades are operating correctly, You agree to uninstall any prior versions of the Software from all computers on which is was previously installed
            </li>
            <li>
              <b>ENTIRE AGREEMENT.</b>
              This CLSSLA is the entire agreement between You and Cirrus Link relating to your use of the Software, and supersedes all prior written or oral statements, promises, representations and agreements.
            </li>
            <li>
            <b>GOVERNING LAW.</b>
              The CLSSLA shall be governed by the laws of the State of Kansas.
              Any action or proceeding brought by either party against the other arising out of or related to this CLSSLA shall be brought only in a state or federal court of competent jurisdiction located in Johnson County, Kansas.
              The parties hereby consent to the jurisdiction of such courts.
            </li>
            <li>
              <b>RIGHT TO IDENTIFY CUSTOMER IN MARKETING MATERIALS.</b>
              You agree that Cirrus Link may use your name (and logo if applicable) in its marketing materials solely for the purpose of identifying customers of Cirrus Link who have purchased its software.
              No explicit representations or warranties shall be made regarding your recommendation or endorsement of the Software.
            </li>
        </ol>
      </div>
    </div>
</template>

<script>
/**
 * EULA Text
 */
export default {
  name: 'EULA-Text',
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
  .alpha-list-style {
    list-style-type: upper-alpha;

    li {
      margin-top: 1rem;
    }
  }

  .eula-body {
    max-height: 500px;
    overflow-y: scroll;
    font-size:12px;
    text-align: left;
  }
</style>
